const prefix = "BUDGET_SEARCH";
const createActionTypes = (resource) => ({
  LOAD: `${prefix}/${resource}/LOAD'`,
  LOADING: `${prefix}/${resource}/LOADING'`,
  LOADED: `${prefix}/${resource}/LOADED'`
});
const loadTrafficFiltersActionTypes = createActionTypes("LOAD_TRAFFIC_FILTERS");
const loadFlightControlActionTypes = createActionTypes("LOAD_FLIGHT_CONTROL");
const loadTrafficFilters = (workspaceId, managementGroup) => {
  return {
    type: loadTrafficFiltersActionTypes.LOAD,
    payload: {
      workspaceId,
      managementGroup
    }
  };
};
const loadingTrafficFilters = (payload) => {
  return {
    type: loadTrafficFiltersActionTypes.LOADING,
    payload
  };
};
const loadedTrafficFilters = (payload, result) => {
  return {
    type: loadTrafficFiltersActionTypes.LOADED,
    payload: {
      result,
      managementGroup: payload.managementGroup,
      workspaceId: payload.workspaceId
    }
  };
};
const loadFlightControl = (workspaceId, managementGroup) => {
  return {
    type: loadFlightControlActionTypes.LOAD,
    payload: {
      workspaceId,
      managementGroup
    }
  };
};
const loadingFlightControl = (payload) => {
  return {
    type: loadFlightControlActionTypes.LOADING,
    payload
  };
};
const loadedFlightControl = (payload, result) => {
  return {
    type: loadFlightControlActionTypes.LOADED,
    payload: {
      result,
      managementGroup: payload.managementGroup,
      workspaceId: payload.workspaceId
    }
  };
};
export {
  loadFlightControl,
  loadFlightControlActionTypes,
  loadTrafficFilters,
  loadTrafficFiltersActionTypes,
  loadedFlightControl,
  loadedTrafficFilters,
  loadingFlightControl,
  loadingTrafficFilters
};
//# sourceMappingURL=SearchFilters.ducks.js.map
